import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_INTERNAL_FILE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseInternalFileAttachments(
    $parents: [TsrctAttachmentParentInput!]!
    $filter: TsrctAttachmentFilterInput
  ) {
    tesseract {
      attachments(parents: $parents, filter: $filter) {
        ...FileAttachment
      }
    }
  }
`);

export const NEGOTIATION_CASE_INTERNAL_FILE_ATTACHMENTS_CASE_AND_DEMAND_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseInternalFileAttachmentsCaseAndDemand($negotiationCaseId: UUID!) {
    tesseract {
      negotiationCase(id: $negotiationCaseId) {
        id
        status
        demand {
          id
        }
      }
    }
  }
`);
